export const USER_DETAILS = 'userDetails';
export const PORTFOLIO = 'portfolio';
export const SET_LANGUAGE = 'currentLang'
export const SET_PORTFOLIO_ITEM = 'portfolioItem'